"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APSelect = _interopRequireDefault(require("../../../../common/APSelect"));
var _APButton = _interopRequireDefault(require("../../../../common/APButton"));
var _ContentWithFooterLayoutTemplate = _interopRequireDefault(require("../../../../common/LayoutTemplates/ContentWithFooterLayoutTemplate/ContentWithFooterLayoutTemplate"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _userActions = require("../../../../../redux/actions/userActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('theme-form');
var EmailFormEditable = function EmailFormEditable(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("auth"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_ContentWithFooterLayoutTemplate["default"], {
    footer: /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
      customClass: baseClasses(),
      onClick: props.handleSubmit
    }, t("Save")),
    customClass: "retail-region-editable-cwf-lt"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('input-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "SendOrderEmails",
    label: t("Order Emails"),
    customClass: baseClasses(),
    options: [{
      value: 'true',
      label: 'Enabled'
    }, {
      value: 'false',
      label: 'Disabled'
    }]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('input-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "LoginEmailOptOut",
    label: t("Login Emails"),
    customClass: baseClasses(),
    options: [{
      value: 'false',
      label: 'Enabled'
    }, {
      value: 'True',
      label: 'Disabled'
    }]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('input-wrapper')
  }))));
};
var mapStateToProps = function mapStateToProps(state) {
  var config = state.user.userConfig.find(function (i) {
    return i.Key === 'SendOrderEmails';
  });
  var loginConfig = state.user.userConfig.find(function (i) {
    return i.Key === 'LoginEmailOptOut';
  });
  var SendOrderEmails = 'true';
  var LoginEmailOptOut = 'false';
  if (config) {
    SendOrderEmails = config.Value;
  }
  if (loginConfig) {
    LoginEmailOptOut = loginConfig.Value;
  }
  return {
    UserId: state.user.UserId,
    UserName: state.user.UserName,
    SendOrderEmails: SendOrderEmails,
    LoginEmailOptOut: LoginEmailOptOut,
    initialValues: {
      SendOrderEmails: SendOrderEmails,
      LoginEmailOptOut: LoginEmailOptOut
    }
  };
};
var form = (0, _reduxForm.reduxForm)({
  form: 'emailSettings',
  enableReinitialize: true,
  onSubmit: function onSubmit(_ref, dispatch, _ref2) {
    var SendOrderEmails = _ref.SendOrderEmails,
      LoginEmailOptOut = _ref.LoginEmailOptOut;
    var UserId = _ref2.UserId,
      UserName = _ref2.UserName,
      toggleModal = _ref2.toggleModal;
    dispatch((0, _userActions.setUserConfig)(UserId, UserName, [{
      Key: 'SendOrderEmails',
      Value: SendOrderEmails
    }], false));
    dispatch((0, _userActions.setUserConfig)(UserId, UserName, [{
      Key: 'LoginEmailOptOut',
      Value: LoginEmailOptOut
    }], false));
    dispatch((0, _userActions.getUserInfo)(UserId));
    toggleModal();
  }
})(EmailFormEditable);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(form);